import { getEmbedUrl, getVideoProvider } from 'Video/Video'

export const initialise = () => {
    const banners = document.querySelectorAll<HTMLElement>('.banner-video')

    banners.forEach(banner => {
        const video = banner.querySelector<HTMLVideoElement>('video')
        const iframe = banner.querySelector<HTMLIFrameElement>('iframe')
        const button = banner.querySelector<HTMLButtonElement>('button:not(.close-button)')
        const closeButton = banner.querySelector<HTMLButtonElement>('button.close-button')

        if (!button) {
            banner.classList.add('playing')
        }

        if (video) {
            button?.addEventListener('click', () => {
                banner.classList.add('playing')
                video.play()
            })
        }
        
        if (iframe) {
            const originalSrc = iframe.src
            button?.addEventListener('click', () => {
                banner.classList.add('playing')
                const videoProvider = getVideoProvider(iframe.src)
                if (!videoProvider) return
                const embedUrl = getEmbedUrl(iframe.src, videoProvider)
                if (!embedUrl) return
                iframe.src = embedUrl
            })

            closeButton?.addEventListener('click', () => {
                banner.classList.remove('playing')
                iframe.src = originalSrc // Unload the iframe to stop the video from playing
            })
        }
    })
}